import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormLabel } from 'react-bootstrap';

type Props = {
  required?: boolean;
  className?: string;
  children: ReactNode;
};

export const Label = ({ required, className, children }: Props) => {
  return (
    <FormLabel className={classNames('u-fs-2 fw-bold', className)}>
      {children}
      {required && <span className="u-color-red1 ps-1 ">*</span>}
    </FormLabel>
  );
};
